import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import cx from 'classnames';
import { MenuNavLink } from 'src/client/containers/HeaderBar/styles';

type Props = {
  show?: boolean;
  url: string;
  children: React.ReactNode;
  path: unknown;
};

export const InternalMenuLink = (props: Props) => {
  const location = useLocation();

  if (props.show === false) {
    return null;
  }

  const active = !!matchPath(location.pathname, { path: props.path as string | string[], exact: true });

  return (
    <MenuNavLink to={props.url} className={cx({ active })}>
      {props.children}
    </MenuNavLink>
  );
};
